import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../utils/api";
import "./InvoicePage.css";

const InvoicePage = () => {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);

  /* ================= FAST FETCH ================= */

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const res = await api.get(`/api/orders/${orderId}`, {
          cache: "no-store",
        });
        setOrder(res.data);
      } catch (err) {
        console.error("Invoice fetch error:", err);
      }
    };

    fetchOrder();
  }, [orderId]);

  const handlePrint = () => {
    setTimeout(() => window.print(), 300);
  };

  if (!order) {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        Loading Invoice...
      </div>
    );
  }

  const items = order.items || order.orderItems || [];

  const total =
    order.totalAmount ||
    order.totalPrice ||
    order.amount ||
    0;

  return (
    <div className="invoice-wrapper">

      <div className="invoice-box">

        {/* HEADER */}
        <div className="invoice-header">
          <div>
            <h2>FreshCart</h2>
            <p>GST: 10BSNPT0153M1CW</p>
            <p>Email: freshcart585@gmail.com</p>
          </div>

          <div>
            <h3>INVOICE</h3>
            <p><strong>Order ID:</strong> {order._id}</p>
            <p>
              <strong>Date:</strong>{" "}
              {new Date(order.createdAt).toLocaleDateString()}
            </p>
          </div>
        </div>

        {/* CUSTOMER */}
        <div className="invoice-section">
          <h4>Bill To</h4>
          <p>{order.shippingAddress?.name}</p>
          <p>{order.shippingAddress?.address}</p>
          <p>
            {order.shippingAddress?.city} -{" "}
            {order.shippingAddress?.pincode}
          </p>
        </div>

        {/* ITEMS */}
        <table className="invoice-table">
          <thead>
            <tr>
              <th>Item</th>
              <th>Qty</th>
              <th>Price</th>
              <th>Total</th>
            </tr>
          </thead>

          <tbody>
            {items.map((item, index) => (
              <tr key={index}>
                <td>{item.name || item.product?.name}</td>
                <td>{item.quantity || item.qty}</td>
                <td>₹{item.price}</td>
                <td>
                  ₹
                  {(item.quantity || item.qty) *
                    item.price}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* TOTAL */}
        <div className="invoice-total">
          <h3>Total: ₹{total}</h3>
          <p>
            Payment:{" "}
            {order.paymentMethod === "PHONEPE"
              ? "Paid Online"
              : "Cash on Delivery"}
          </p>
        </div>

        {/* PRINT */}
        <div className="invoice-footer">
          <button onClick={handlePrint} className="print-btn">
            Print Invoice
          </button>
        </div>

      </div>
    </div>
  );
};

export default InvoicePage;